import noop from 'lodash/noop';
import range from 'lodash/range';
import memoize from 'memoize-one';
import moment from 'moment-timezone';
import React, { useCallback } from 'react';

import SearchInput from '../SearchInput';
import styles from './styles/TimeSelector.less';

const dateFormat = 'MMM D YYYY';

const getOptions = memoize((granularity) => {
  let g = granularity;
  const options = [];
  if (!granularity || 60 % granularity !== 0) {
    g = 60;
  }
  range(24).forEach((h) => {
    range(60 / g).forEach((t) => {
      const minute = `${t * g}`.padStart(2, '0');
      const val = `${`${h}`.padStart(2, '0')}:${minute}`;
      options.push({
        text: val,
        value: val,
      });
    });
  });
  return options;
});

const filterFunc = (input, options, minutely) => {
  if (!input || !minutely) {
    return options;
  }
  const result = options.filter((option) => option.text.startsWith(input));
  const values = result.map((r) => r.value);
  if (moment(input, 'HH:mm', true).isValid() && !values.includes(input)) {
    result.push({
      text: input,
      value: input,
    });
  }
  return result;
};

const TimeSelector = ({ time, onChange, disabled, granularity, id, minutely }) => {
  const options = getOptions(granularity);
  const filterOptions = useCallback(
    (value) => ({ data: filterFunc(value, options, minutely) }),
    [options, minutely],
  );
  return (
    <div id={id} className={styles.timeSelector}>
      <span className={styles.day}>{time.format(dateFormat)}</span>
      <SearchInput
        key={JSON.stringify(options)}
        value={{ label: time.format('HH:mm'), key: time.format('HH:mm') }}
        notFoundContent={null}
        onSearch={filterOptions}
        onChange={onChange}
        defaultData={options}
        disabled={disabled}
      />
    </div>
  );
};

TimeSelector.defaultProps = {
  onChange: noop,
  granularity: 5,
  disabled: false,
  id: '',
  minutely: false,
};

export default TimeSelector;
